import React, { useEffect } from "react";
import useTypeDecription from "../../../hooks/useTypeDecription";
import LinkQrWrapper from "../linkPage/LinkQrWrapper";
import VenmoIcon from "./svg/VenmoIcon";
import { useSelector } from "react-redux";

export default function VenmoPage() {
  const lang = useSelector(
    (state) => state.changeLang.language.stepTwo.venmo
  );
  const { content, getContent } = useTypeDecription();

  useEffect(() => {
    getContent("venmo");
  }, []);

  return (
    <LinkQrWrapper
      prefixIcon={<VenmoIcon />}
      fieldPlaceholder={lang[0]}
      popoverText={lang[1]}
    >
      {content}
    </LinkQrWrapper>
  );
}
